import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/report/SafeDrivingDailyGraph/.eu';

export interface SafeDrivingDailyGraphProps {
  vin: string;
  selectedMonth: string;
}

export default function SafeDrivingDailyGraph({vin, selectedMonth}: SafeDrivingDailyGraphProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu
            selectedMonth={selectedMonth}
            vin={vin}
          />
        </Environment.Kia>
      </Environment.Eu>
    </>
  );
}
